ScoreCardAPIService = ($http, $q, cache) ->

  getMyAvg: (id,params) ->
    $http.get("/api/users/#{id}/score_cards/analysis.json", params: params)

  getBestWorst: (id,params) ->
    $http.get("/api/users/#{id}/score_cards/best_worst_analysis.json", params: params)

  getAllMembers: (params) ->
    defer = $q.defer()
    $http.get("/api/score_cards/all/analysis.json", params: params)
      .then (resp) ->
        defer.resolve resp.data
    defer.promise

  getAllMembersByEvent: (id,params) ->
    defer = $q.defer()
    allMembersInfoEvent = cache.get('allMembersInfoEvent')

    if allMembersInfoEvent? && allMembersInfoEvent.event_id == "#{id}"
      defer.resolve allMembersInfoEvent
    else
      $http.get("/api/group_events/#{id}/analysis.json", params: params)
        .then (resp) ->
          resp.data.event_id = id
          cache.put('allMembersInfoEvent', resp.data)
          defer.resolve resp.data

    defer.promise

  clearAllMembersByEventData: (id) ->
    allMembersInfoEvent = cache.get('allMembersInfoEvent')
    if allMembersInfoEvent? && allMembersInfoEvent.event_id == "#{id}"
      cache.remove('allMembersInfoEvent')

ScoreCardAPIService.$inject = [
  '$http'
  '$q'
  'cache'
]

module.exports = ScoreCardAPIService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/remote-api/score-card-api-service.coffee